import PasswordAuthProvider, { useAuth as PasswordUseAuth } from 'contexts/passwordAuth';

const useAuth = () => {
    return PasswordUseAuth();
};

const AuthProvider = ({ children }) => {
    return <PasswordAuthProvider>{children}</PasswordAuthProvider>;
};

export { useAuth };
export default AuthProvider;
